import apiCall from "./apiCall";
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  fetchRoleList:    (data) => apiCall("role/list",              data),
  createRole:       (data) => apiCall("role/create",            data),
  getRoleWithPerms: (data) => apiCall("role/get",               data),
};
